import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=1f9d698e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=1f9d698e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9d698e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f9d698e')) {
      api.createRecord('1f9d698e', component.options)
    } else {
      api.reload('1f9d698e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=1f9d698e&scoped=true&", function () {
      api.rerender('1f9d698e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21hKcRwY2fGbs/JS/comp/SearchFilterTokens.vue"
export default component.exports